(function () {
  var STORAGE_KEY = 'ata_wishlist';
  var CACHE_KEY = 'ata_wishlist_cache';
  var CACHE_TTL = 10 * 60 * 1000; // 10 minutes

  var style = document.createElement('style');
  style.textContent =
    '.wishlist-toast{position:fixed;left:50%;bottom:24px;transform:translate(-50%,20px);background:#1B2C58;color:#fff;padding:12px 18px;border-radius:8px;display:flex;align-items:center;gap:14px;font-size:13px;opacity:0;pointer-events:none;transition:opacity .25s ease,transform .25s ease;z-index:10000;box-shadow:0 4px 16px rgba(0,0,0,.2);}' +
    '.wishlist-toast.is-visible{opacity:1;transform:translate(-50%,0);pointer-events:auto;}' +
    '.wishlist-toast__action{background:none;border:none;color:#fff;text-decoration:underline;font-size:13px;cursor:pointer;white-space:nowrap;}' +
    '[data-wishlist-toggle]{transition:transform .15s ease;}' +
    '[data-wishlist-toggle].wishlist-pulse{animation:wishlistPulse .35s ease;}' +
    '@keyframes wishlistPulse{0%{transform:scale(1);}40%{transform:scale(1.25);}100%{transform:scale(1);}}' +
    '.wishlist-drawer__item-size{font-size:12px;color:#888;}' +
    '.wishlist-drawer__item-price{display:flex;align-items:center;gap:6px;}' +
    '.wishlist-drawer__item-compare{color:#999;text-decoration:line-through;font-size:12px;}' +
    '.wishlist-drawer__item-move:disabled{opacity:.5;cursor:default;}' +
    '.cart-item__move-to-wishlist{margin-inline-start:12px;background:none;border:none;padding:0;cursor:pointer;font-size:12px;color:#999;text-decoration:underline;}';
  document.head.appendChild(style);

  function getVariantId() {
    var input = document.querySelector('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
    return input ? input.value : null;
  }

  var toastTimer;
  function showToast(message) {
    var toast = document.getElementById('wishlist-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'wishlist-toast';
      toast.className = 'wishlist-toast';
      var text = document.createElement('span');
      text.className = 'wishlist-toast__text';
      toast.appendChild(text);
      var action = document.createElement('button');
      action.type = 'button';
      action.className = 'wishlist-toast__action';
      action.textContent = 'צפייה ברשימה';
      action.addEventListener('click', function () {
        hideToast();
        var toggleBtn = document.getElementById('wishlist-drawer-toggle');
        if (toggleBtn) toggleBtn.click();
      });
      toast.appendChild(action);
      document.body.appendChild(toast);
    }
    toast.querySelector('.wishlist-toast__text').textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 2500);
  }

  function hideToast() {
    var toast = document.getElementById('wishlist-toast');
    if (toast) toast.classList.remove('is-visible');
  }

  function animateToggle(btn) {
    btn.classList.remove('wishlist-pulse');
    void btn.offsetWidth;
    btn.classList.add('wishlist-pulse');
  }

  /* ---- Wishlist storage: array of { handle, variantId } ---- */
  function getWishlist() {
    try {
      var raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return raw.map(function (entry) {
        if (typeof entry === 'string') {
          return { handle: entry, variantId: null };
        }
        return entry;
      });
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { list: list } }));
  }

  function findIndex(list, handle, variantId) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].handle === handle && String(list[i].variantId) === String(variantId)) {
        return i;
      }
    }
    return -1;
  }

  function isInWishlist(handle, variantId) {
    return findIndex(getWishlist(), handle, variantId) !== -1;
  }

  function toggleWishlist(handle, variantId) {
    var list = getWishlist();
    var index = findIndex(list, handle, variantId);
    if (index === -1) {
      list.push({ handle: handle, variantId: variantId });
    } else {
      list.splice(index, 1);
    }
    saveWishlist(list);
    return index === -1;
  }

  function removeFromWishlist(handle, variantId) {
    var list = getWishlist();
    var index = findIndex(list, handle, variantId);
    if (index !== -1) {
      list.splice(index, 1);
      saveWishlist(list);
    }
  }

  function updateCountBadges() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
    });
  }

  function updateButtonStates() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-wishlist-toggle');
      var variantId = getVariantId();
      var saved = isInWishlist(handle, variantId);
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-pressed', saved);
    });
  }

  document.addEventListener('wishlist:updated', updateCountBadges);
  document.addEventListener('wishlist:updated', updateButtonStates);
  document.addEventListener('DOMContentLoaded', function () {
    updateCountBadges();
    updateButtonStates();
  });

  /* Poll for size/variant changes on PDP so the heart reflects the selected size */
  var lastVariantId = null;
  setInterval(function () {
    var vid = getVariantId();
    if (vid !== lastVariantId) {
      lastVariantId = vid;
      updateButtonStates();
    }
  }, 400);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-wishlist-toggle');
    var variantId = getVariantId();
    var added = toggleWishlist(handle, variantId);
    updateButtonStates();
    animateToggle(btn);
    showToast(added ? 'נוסף לפריטים שאהבת' : 'הוסר מהפריטים שאהבת');
  });

  window.ataWishlist = {
    get: getWishlist,
    isSaved: isInWishlist,
    toggle: toggleWishlist,
    remove: removeFromWishlist
  };

  /* ---- Product data cache (speeds up drawer renders, expires after CACHE_TTL) ---- */
  function getCache() {
    try {
      return JSON.parse(localStorage.getItem(CACHE_KEY) || '{}');
    } catch (e) {
      return {};
    }
  }

  function setCacheEntry(handle, product) {
    var cache = getCache();
    cache[handle] = { data: product, ts: Date.now() };
    localStorage.setItem(CACHE_KEY, JSON.stringify(cache));
  }

  function fetchProduct(handle) {
    var cache = getCache();
    var entry = cache[handle];
    if (entry && (Date.now() - entry.ts) < CACHE_TTL) {
      return Promise.resolve(entry.data);
    }
    return fetch('/products/' + handle + '.js')
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (product) {
        if (product) setCacheEntry(handle, product);
        return product;
      });
  }

    function formatMoney(cents) {
    return '₪ ' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function getFixedPriceTag(product) {
    var fixedPrice = 0;
    (product.tags || []).forEach(function (t) {
      if (t.indexOf('קיץ') !== -1) {
        var clean = t.replace(/קיץ/g, '').replace(/[-–—\s]/g, '');
        if (clean === '100' || clean === '200' || clean === '300' || clean === '400') {
          fixedPrice = parseInt(clean, 10);
        }
      }
    });
    return fixedPrice;
  }

  function getDisplayPricing(product, variant) {
    var price = variant ? variant.price : product.price;
    var compareAt = variant ? variant.compare_at_price : product.compare_at_price;
    var fixedTag = product.available !== false ? getFixedPriceTag(product) : 0;
    if (fixedTag > 0) {
      var originalPrice = compareAt;
      if (!originalPrice || originalPrice <= price) {
        originalPrice = price;
      }
      compareAt = originalPrice;
      price = fixedTag * 100;
    }
    return { price: price, compareAt: compareAt };
  }

  /* ---- Drawer ---- */
  var drawer, drawerOpen = false;

  function renderDrawer() {
    var itemsEl = document.getElementById('wishlist-drawer-items');
    var emptyEl = document.getElementById('wishlist-drawer-empty');
    if (!itemsEl || !emptyEl) return;

    var entries = getWishlist();
    if (entries.length === 0) {
      itemsEl.innerHTML = '';
      emptyEl.hidden = false;
      return;
    }
    emptyEl.hidden = true;

    Promise.all(entries.map(function (entry) { return fetchProduct(entry.handle); })).then(function (products) {
      itemsEl.innerHTML = products.map(function (product, i) {
        if (!product) return '';
        var entry = entries[i];
        var variant = null;
        if (entry.variantId) {
          variant = product.variants.filter(function (v) { return String(v.id) === String(entry.variantId); })[0];
        }
        if (!variant) variant = product.variants[0];
        var sizeLabel = variant ? (variant.title || variant.option1) : '';
        var pricing = getDisplayPricing(product, variant);
        var priceCents = pricing.price;
        var compareCents = pricing.compareAt;
        var hasDiscount = compareCents && compareCents > priceCents;
        var available = variant ? variant.available : true;

        var priceHtml = '<span class="wishlist-drawer__item-price">' +
          '<span>' + formatMoney(priceCents) + '</span>' +
          (hasDiscount ? '<span class="wishlist-drawer__item-compare">' + formatMoney(compareCents) + '</span>' : '') +
          '</span>';

        var moveBtnHtml = available
          ? '<button type="button" class="wishlist-drawer__item-move" data-wishlist-move="' + product.handle + '" data-variant-id="' + (variant ? variant.id : '') + '">הוסף לעגלה</button>'
          : '<button type="button" class="wishlist-drawer__item-move" disabled>אזל המלאי</button>';

        return (
          '<div class="wishlist-drawer__item">' +
            '<a href="/products/' + product.handle + '"><img class="wishlist-drawer__item-image" src="' + (product.featured_image || '') + '" alt="' + product.title.replace(/"/g, '&quot;') + '"></a>' +
            '<div class="wishlist-drawer__item-info">' +
              '<a class="wishlist-drawer__item-title" href="/products/' + product.handle + '">' + product.title + '</a>' +
              (sizeLabel ? '<span class="wishlist-drawer__item-size">מידה: ' + sizeLabel + '</span>' : '') +
              priceHtml +
              '<div class="wishlist-drawer__item-actions">' +
                moveBtnHtml +
                '<button type="button" class="wishlist-drawer__item-remove" data-wishlist-remove="' + product.handle + '" data-variant-id="' + (entry.variantId || '') + '">הסר</button>' +
              '</div>' +
            '</div>' +
          '</div>'
        );
      }).join('');
    });
  }

  function openDrawer() {
    drawer = drawer || document.getElementById('wishlist-drawer');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawerOpen = true;
    renderDrawer();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawerOpen = false;
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-link__count').forEach(function (el) {
          el.textContent = cart.item_count > 0 ? cart.item_count : '';
        });
      });
  }

  function refreshCartDrawer() {
    var cartForm = document.querySelector('cart-form.cart-drawer[data-section-id]');
    if (!cartForm) return;
    var sectionId = cartForm.getAttribute('data-section-id');
    fetch('/?section_id=' + sectionId)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newCartForm = doc.querySelector('cart-form.cart-drawer[data-section-id]');
        if (newCartForm) {
          cartForm.replaceWith(newCartForm);
        }
      });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('#wishlist-drawer-toggle')) {
      e.preventDefault();
      openDrawer();
    } else if (e.target.closest('[data-wishlist-drawer-close]')) {
      e.preventDefault();
      closeDrawer();
    } else if (e.target.closest('[data-wishlist-remove]')) {
      e.preventDefault();
      var removeBtn = e.target.closest('[data-wishlist-remove]');
      var removeHandle = removeBtn.getAttribute('data-wishlist-remove');
      var removeVariantId = removeBtn.getAttribute('data-variant-id');
      removeFromWishlist(removeHandle, removeVariantId);
      updateButtonStates();
    } else if (e.target.closest('[data-wishlist-move]')) {
      e.preventDefault();
      var moveBtn = e.target.closest('[data-wishlist-move]');
      if (moveBtn.disabled) return;
      var moveHandle = moveBtn.getAttribute('data-wishlist-move');
      var moveVariantId = moveBtn.getAttribute('data-variant-id');
      if (!moveVariantId) return;
      moveBtn.disabled = true;
      moveBtn.textContent = 'מוסיף...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: moveVariantId, quantity: 1 })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          removeFromWishlist(moveHandle, moveVariantId);
          updateCartCount();
          refreshCartDrawer();
        });
    } else if (e.target.closest('[data-cart-move-to-wishlist]')) {
      e.preventDefault();
      var moveToWishlistBtn = e.target.closest('[data-cart-move-to-wishlist]');
      var cartHandle = moveToWishlistBtn.getAttribute('data-handle');
      var cartVariantId = moveToWishlistBtn.getAttribute('data-variant-id');
      var cartLineKey = moveToWishlistBtn.getAttribute('data-line-key');
      moveToWishlistBtn.disabled = true;
      moveToWishlistBtn.textContent = 'מעביר...';

      var list = getWishlist();
      if (findIndex(list, cartHandle, cartVariantId) === -1) {
        list.push({ handle: cartHandle, variantId: cartVariantId });
        saveWishlist(list);
      }
      updateButtonStates();

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: cartLineKey, quantity: 0 })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          updateCartCount();
          refreshCartDrawer();
          showToast('נוסף לפריטים שאהבת');
        });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawerOpen) closeDrawer();
  });

  document.addEventListener('wishlist:updated', function () {
    if (drawerOpen) renderDrawer();
  });

  document.addEventListener('DOMContentLoaded', function () {
    var el = document.getElementById('wishlist-drawer');
    if (el && el.parentNode !== document.body) {
      document.body.appendChild(el);
    }
  });
})();